import { connect } from 'react-redux';

import MessageInput from './';

import { addMessage, saveMessageInputData, setTyping } from '../../actions/chatActions';

const mapStateToProps = (state, ownProps) => {
  const chatId = parseInt(ownProps.chatId, 10);
  const chat = state.chats[chatId];
  const messageInputData = chat
    ? chat.messageInputData
    : undefined;
  return { messageInputData };
};

const mapDispatchToProps = dispatch => ({
  addMessage: (chatId, content, contentType, files) => {
    dispatch(addMessage(chatId, content, contentType, files))
  },
  saveMessageInputData: (chatId, messageInputData) => {
    dispatch(saveMessageInputData(chatId, messageInputData))
  },
  setTyping: (chatId, typing) => {
    dispatch(setTyping(chatId, typing));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageInput);
